
<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="$t('pages.promociones')"
  >
    <PromocionesLista @cambiado="cambiado = $event"/>
  </page-layout>
</template>

<script>
import PromocionesLista from '@/components/promociones/PromocionesLista'

export default {
  components: {
    PromocionesLista
  },
  data () {
    return {
      cambiado: false
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: this.$t('pages.home'),
          disabled: false,
          exact: true,
          to: {name: 'home'}
        },
        {
          text: this.$t('pages.promociones'),
          disabled: true,
          exact: true
        }
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiado) {
      let respuesta = confirm(this.$t('general.misc.alertPreRefresh'))
      if (respuesta) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/promociones/promociones.vue